import { Tag } from "antd";
import React from "react";
import { $t } from "~/i18n.js";
import { _parseDate } from "~/lib/localize.js";
import { DateFormat } from "../date/DateFormat.jsx";

export const ParseTrainingFlightDate = ({
  last_check_start,
  hideOnbekendTag = false,
}) => {
  if (!last_check_start & !hideOnbekendTag)
    return <Tag color="red">{$t("onbekend")}</Tag>;
  if (!last_check_start) return null;

  return <ParseMultipleDateWithPossibleError dates={last_check_start} />;
};

export const ParseMultipleDateWithPossibleError = ({
  dates,
  checkDateInPast = true,
  maxDays = 600,
}) => {
  return (
    <>
      {dates.split(",").map((d, i) => {
        // Check if date is longer than 1.7 years ago, so nearing the end
        const setWarning = checkDateInPast
          ? new Date() - new Date(d) > maxDays * 1000 * 60 * 60 * 24
          : new Date(d) - new Date() < maxDays * 1000 * 60 * 60 * 24;

        return (
          <Tag
            key={i}
            color={setWarning && "red"}
            style={{ fontSize: 10, padding: 2, lineHeight: 1.2 }}
          >
            <DateFormat date={d} />
          </Tag>
        );
      })}
    </>
  );
};